module.exports = __webpack_public_path__ + "static/media/p3.bd7797ea.pdf";